import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react';
import Fade from 'react-reveal/Fade';
import img1 from '../../assets/images/office.jpeg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons'
import "../../assets/css/location.css"
const AnyReactComponent = ({ text }) => <div>{text}</div>;
class Location extends Component {
  static defaultProps = {
    center: {
      lat: 35.8125,
      lng: 10.638
    },
    zoom: 18
  };

  render() {
    return (
      <div className="mainContloc">
        <Fade left>
          <h2>Find Us</h2>
        </Fade>
        <div className="locCont">
            <div className="locDesc">
              <FontAwesomeIcon icon={faMapMarkerAlt} className="icon" />
              <div>

                <p> Baltimore Maryland, 21211</p>
                <p>1014 W 36th St</p>
                <p> Unit #52</p>
                <p>United States</p>
              </div>
            </div>
            <div>
            <Fade left>
            <img src={img1} width="400px" alt="Office" />
            </Fade>
              {/* <GoogleMapReact
                bootstrapURLKeys={{ key: 'AIzaSyBz9rIbNj6weJLBashJmUo7DnY_qeYmGqA&v' }}
                defaultCenter={this.props.center}
                defaultZoom={this.props.zoom}
              > */}
                {/* <AnyReactComponent
                  lat={39.33126}
                  lng={76.63352}
                  text="My Marker"
                /> */}
              {/* </GoogleMapReact> */}
            </div>
        </div>

      </div>

    );
  }
}

export default Location;